(function () {
    'use strict';

    angular
        .module('recomActionPlanUpdateStatusReviewControllers')
        .controller('RecomUpdateStatusAssessByQuarterReviewController', Controller);

    Controller.$inject = ['$scope', 'topBarService', 'bUnit', 'govProcess', 'assessmentsByActionPlan', 'criteriaAssessmentsByQuarter', 'fiscalYearQuarterKeys'];

    function Controller($scope, topBarService, bUnit, govProcess, assessmentsByActionPlan, criteriaAssessmentsByQuarter, fiscalYearQuarterKeys) {

        var title = bUnit.TitleEN + ' Action Plans | ' + govProcess.ShortName + ' Progress Tracking';
        topBarService.setTitleAndIcon(title, 'fa fa-road');

        $scope.bUnit = bUnit;
        $scope.govProcess = govProcess;
        $scope.ctrlCtxt = {};

        $scope.actionPlanStatusList = assessmentsByActionPlan.ActionPlanStatusList;
        $scope.actionPlan = assessmentsByActionPlan.ActionPlan;
        $scope.actionPlanAssessment = assessmentsByActionPlan.ActionPlanAssessment;
        $scope.assessmentsByActionPlan = _.omit(assessmentsByActionPlan, 'ActionPlanCriteriaAssessments');
        $scope.criteriaAssessmentsByQuarter = criteriaAssessmentsByQuarter;
        $scope.fiscalYearQuarterKeys = fiscalYearQuarterKeys;
    }
})();